"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCancellablePromise;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.find.js");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/wrapNativeSuper"));

var _react = require("react");

var CanceledPromiseError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(CanceledPromiseError, _Error);

  var _super = (0, _createSuper2.default)(CanceledPromiseError);

  function CanceledPromiseError(message) {
    var _this;

    (0, _classCallCheck2.default)(this, CanceledPromiseError);
    _this = _super.call(this, message);
    _this.isCanceled = true;
    return _this;
  }

  return (0, _createClass2.default)(CanceledPromiseError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 * @info took and modified from https://github.com/rajeshnaroth/react-cancelable-promise-hook
 * @returns {{cancellablePromise: (function(*=): Promise<any>)}}
 */


function useCancellablePromise() {
  var cancelable = (0, _react.useCallback)(function (promise) {
    var isCanceled = false;
    var canceller;
    var timeout = new Promise(function (resolve, reject) {
      canceller = function canceller() {
        return reject(new CanceledPromiseError("Cancelled Promise"));
      };
    });
    var wrappedPromise = new Promise(function (resolve, reject) {
      promise.then(function (val) {
        return isCanceled ? reject(new CanceledPromiseError("Cancelled Promise (resolved): value (".concat((0, _typeof2.default)(val), "): ").concat(val))) : resolve(val);
      }).catch(function (error) {
        return isCanceled ? reject(new CanceledPromiseError("Cancelled Promise (rejected): err: ".concat(error.message))) : reject(error);
      });
    });
    return {
      promise: Promise.race([timeout, wrappedPromise]),
      cancel: function cancel() {
        isCanceled = true;
        canceller();
      }
    };
  }, []);
  var promises = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    promises.current = promises.current || [];
    return function cancel() {
      promises.current.forEach(function (p) {
        return p.cancel();
      });
      promises.current = [];
    };
  }, []);
  var cancellablePromise = (0, _react.useCallback)(function (p) {
    var cPromise = cancelable(p);
    promises.current.push(cPromise);
    return cPromise.promise; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var cancelPromise = (0, _react.useCallback)(function (p) {
    var wrappedPromise = promises.current.find(function (wp) {
      return wp.promise === p;
    });

    if (wrappedPromise) {
      wrappedPromise.cancel();
    } else {
      console.log('no promise to cancel');
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return {
    cancellablePromise: cancellablePromise,
    cancelPromise: cancelPromise
  };
}